import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import CountContext from '../../context/CountContext.js';

export default function TipRemovalScreen({ onNext, onBack }) {
  const { state } = useContext(CountContext);
  const {
    tipBucket: { coins, bills: tipBills, removal: coinRemoval },
    report: { creditTips }
  } = state;
  // 2) Split coins into whole dollars vs cents
  const coinWhole = Math.floor(coins);                   // e.g. 1 from 1.24
  const coinFraction = parseFloat((coins - coinWhole).toFixed(2));  // e.g. 0.24

  // floor credit tips to whole dollars
  const creditTipFloor = Math.floor(creditTips);

  // 1) Compute how many coins remain after rounding
  const roundedCoinAmount = coins - coinRemoval;

  // total cash to remove = bills + whole‐dollar coins + floored credit‐tips
  const totalCashRemoval = tipBills + coinWhole + creditTipFloor;


  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-4">
      <h2 className="text-2xl font-bold">Remove Cash Tips</h2>

      <p>
        You counted <strong>${coins.toFixed(2)}</strong> in tip‑bucket coins and{' '}
        <strong>${tipBills.toFixed(2)}</strong> in tip‑bucket bills.
      </p>
      <p>
        You’ll remove <strong>${coinWhole.toFixed(2)}</strong> of those coins as tips,
        and roll <strong>${coinFraction.toFixed(2)}</strong> back into the bank.
      </p>
      <p>
        Credit‑card tips ({creditTips.toFixed(2)}) rounded down to{' '}
        <strong>${creditTipFloor}</strong>.
      </p>

      <div className="flex justify-center">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
          className="mt-4 text-4xl font-extrabold text-indigo-600"
        >
          Put the cash tips in the drawer, then remove <strong>${totalCashRemoval.toFixed(2)}</strong>
          – in the highest denominations. Set to the side as Tip Cash.
        </motion.div>
      </div>
      <div className="flex justify-between">
        <button
          onClick={onBack}
          className="px-4 py-2 bg-gray-300 rounded"
        >
          Back
        </button>
        <button
          onClick={onNext}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          Confirm Removal
        </button>
      </div>
    </div >
  );
}
